import { useState } from 'react';

export default function BookingSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    time: '',
    tattooType: '',
    size: '',
    placement: '',
    description: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        time: '',
        tattooType: '',
        size: '',
        placement: '',
        description: ''
      });
    }, 3000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const whatsappMessage = `¡Hola! Quiero reservar una cita para un tatuaje 📅%0A%0ANombre: ${formData.name}%0ATeléfono: ${formData.phone}%0ATipo: ${formData.tattooType}%0ATamaño: ${formData.size}%0AZona: ${formData.placement}`;
  const whatsappUrl = `https://wa.me/34658402605?text=${whatsappMessage}`;

  return (
    <section id="reservar" className="py-20 md:py-28 bg-neutral-900 relative overflow-hidden">
      {/* ... existing code ... */}

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left: Info */}
          <div>
            <div className="inline-block px-4 py-2 bg-amber-600/15 border border-amber-600/30 rounded-full mb-6">
              <span className="text-amber-500 text-xs font-bold uppercase tracking-wider">Reserva tu cita</span>
            </div>
            
            <h2 
              className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight"
              style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px' }}
            >
              Comienza tu<br />
              <span className="text-amber-500">Obra de Arte</span>
            </h2>

            <p className="text-neutral-400 text-base md:text-lg leading-relaxed mb-8">
              Completa el formulario o contáctanos directamente por WhatsApp. Te responderemos en menos de 24 horas para confirmar tu cita y resolver cualquier duda sobre tu diseño.
            </p>

            <div className="space-y-5 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-lg flex-shrink-0">
                  <i className="ri-calendar-check-line text-amber-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1">Horario Flexible</h3>
                  <p className="text-neutral-400 text-sm">Lunes a Sábado de 10:00 a 20:00h</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-lg flex-shrink-0">
                  <i className="ri-user-star-line text-amber-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1">Asesoramiento Personalizado</h3>
                  <p className="text-neutral-400 text-sm">Te ayudamos a elegir el mejor diseño y ubicación</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-600/15 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-amber-500 text-lg"></i>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base mb-1">Máxima Higiene</h3>
                  <p className="text-neutral-400 text-sm">Material esterilizado y desechable en cada sesión</p>
                </div>
              </div>
            </div>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-[#25D366] text-white font-bold rounded-lg hover:bg-[#20BA5A] transition-all hover:scale-105 shadow-lg shadow-[#25D366]/20 whitespace-nowrap cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-xl"></i>
              </div>
              Reservar por WhatsApp
            </a>
          </div>

          {/* Right: Form */}
          <div className="bg-neutral-800/60 border border-neutral-700/50 rounded-2xl p-6 md:p-8 backdrop-blur-sm">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-neutral-300 text-sm font-medium mb-2">
                    Nombre completo *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors"
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-neutral-300 text-sm font-medium mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors"
                    placeholder="+34 600 000 000"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="email" className="block text-neutral-300 text-sm font-medium mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors"
                  placeholder="tu@email.com"
                />
              </div>

              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="date" className="block text-neutral-300 text-sm font-medium mb-2">
                    Fecha preferida
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors cursor-pointer"
                  />
                </div>

                <div>
                  <label htmlFor="time" className="block text-neutral-300 text-sm font-medium mb-2">
                    Hora preferida
                  </label>
                  <select
                    id="time"
                    name="time"
                    value={formData.time}
                    onChange={handleChange}
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors cursor-pointer"
                  >
                    <option value="">Selecciona hora</option>
                    <option value="10:00">10:00</option>
                    <option value="11:00">11:00</option>
                    <option value="12:00">12:00</option>
                    <option value="13:00">13:00</option>
                    <option value="16:00">16:00</option>
                    <option value="17:00">17:00</option>
                    <option value="18:00">18:00</option>
                    <option value="19:00">19:00</option>
                  </select>
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="tattooType" className="block text-neutral-300 text-sm font-medium mb-2">
                    Tipo de tatuaje
                  </label>
                  <select
                    id="tattooType"
                    name="tattooType"
                    value={formData.tattooType}
                    onChange={handleChange}
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors cursor-pointer"
                  >
                    <option value="">Selecciona tipo</option>
                    <option value="Realismo">Realismo</option>
                    <option value="Tradicional">Tradicional</option>
                    <option value="Blackwork">Blackwork</option>
                    <option value="Minimalista">Minimalista</option>
                    <option value="Geométrico">Geométrico</option>
                    <option value="Lettering">Lettering</option>
                    <option value="Cover-up">Cover-up</option>
                    <option value="Otro">Otro</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="size" className="block text-neutral-300 text-sm font-medium mb-2">
                    Tamaño aproximado
                  </label>
                  <select
                    id="size"
                    name="size"
                    value={formData.size}
                    onChange={handleChange}
                    className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors cursor-pointer"
                  >
                    <option value="">Selecciona tamaño</option>
                    <option value="Pequeño (5-10cm)">Pequeño (5-10cm)</option>
                    <option value="Mediano (10-20cm)">Mediano (10-20cm)</option>
                    <option value="Grande (20-30cm)">Grande (20-30cm)</option>
                    <option value="Muy grande (+30cm)">Muy grande (+30cm)</option>
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="placement" className="block text-neutral-300 text-sm font-medium mb-2">
                  Zona del cuerpo
                </label>
                <input
                  type="text"
                  id="placement"
                  name="placement"
                  value={formData.placement}
                  onChange={handleChange}
                  className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors"
                  placeholder="Ej: Brazo, espalda, pierna..."
                />
              </div>

              <div>
                <label htmlFor="description" className="block text-neutral-300 text-sm font-medium mb-2">
                  Describe tu idea
                </label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows={4}
                  maxLength={500}
                  className="w-full bg-neutral-900/50 border border-neutral-700 rounded-lg px-4 py-3 text-white text-sm focus:outline-none focus:border-amber-500 transition-colors resize-none"
                  placeholder="Cuéntanos qué diseño tienes en mente, referencias, colores..."
                ></textarea>
                <p className="text-neutral-500 text-xs mt-1">{formData.description.length}/500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={submitted}
                className="w-full bg-amber-600 text-white font-bold py-4 rounded-lg hover:bg-amber-500 transition-all hover:scale-[1.02] disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '1px', fontSize: '18px' }}
              >
                {submitted ? '✓ Solicitud Enviada' : 'Enviar Solicitud'}
              </button>

              {submitted && (
                <p className="text-green-400 text-sm text-center">
                  ¡Gracias! Te contactaremos pronto para confirmar tu cita.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
